/**
 * Planning entity list — thin wrapper around EntityListPage (§4.7).
 * @deprecated Import EntityListPage from `components/collection` for new surfaces.
 */

import type { ReactNode } from 'react';
import { EntityListPage, type EntityListPageProps } from '../../../components/collection/EntityListPage';
import type { Scenario } from '../../../lib/planningEngineModule.types';

export type PlanningEntityListPageProps<T, SortField extends string = string> = Omit<
  EntityListPageProps<T, SortField>,
  'contextBar' | 'secondaryActions'
> & {
  activeScenario?: Scenario | null;
  /** @deprecated — sync is now automatic. Prop retained for backwards compatibility but ignored. */
  onSync?: () => void | Promise<void>;
  /** @deprecated — sync is now automatic. Prop retained for backwards compatibility but ignored. */
  syncing?: boolean;
  secondaryActions?: ReactNode;
};

export function PlanningEntityListPage<T, SortField extends string = string>({
  activeScenario,
  // onSync and syncing are intentionally unused — sync is automatic
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onSync: _onSync,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  syncing: _syncing,
  secondaryActions,
  className = 'h-full min-h-0',
  shellClassName = 'h-full',
  ...rest
}: PlanningEntityListPageProps<T, SortField>) {
  return (
    <EntityListPage
      {...rest}
      className={className}
      shellClassName={shellClassName}
      secondaryActions={secondaryActions}
      contextBar={
        activeScenario
          ? { label: `Scenario: ${activeScenario.name}` }
          : { label: 'No active scenario — using live items' }
      }
    />
  );
}
